import { trigger, state, style, transition, animate } from '@angular/animations';

export function ListItemAnimation(height: number = 40) {
  return trigger('listItem', [
    state('in', style({
      opacity: 1,
      height: height
    })),
    transition('void => *', [
      style({
        opacity: 0,
        height: 0
      }),
      animate('0.2s ease-out', style({height: height})),
      animate('0.2s', style({opacity: 1}))
    ]),
    transition('* => void', [
      animate('0.2s', style({opacity: 0})),
      animate('0.2s ease-out', style({height: 0}))
    ])
  ]);
}


// WEBPACK FOOTER //
// ./src/app/shared/list-item.animation.ts